module.exports = __webpack_public_path__ + "assets/badge.4352ef23cf5cf998e0b2be98bbbda769.svg";